import React, { useState } from "react";
import { useStylesAlertModal } from "./style";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../assets/images/clear.svg";
import AlertIcon from "../../assets/images/alert-icon.png";
import { hideMsg } from "../../actions/alertAction";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const AlertModal = (props) => {
  // These are all states of the current component
  const { alertMessage, alertMessage2 } = props;
  const classes = useStylesAlertModal();
  const [openAlertModal, setAlertModal] = useState(props.openAlertModal);
  const dispatch = useDispatch();
  const handleAlertCloseModal = () => {
    dispatch(hideMsg());
  };
  const { t } = props;
  const yesHandler = () => {
    props.history.push("/");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light customHeader">
      {/* Balances missing or errors alert modal component */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openAlertModal}
        onClose={handleAlertCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openAlertModal}>
          <div className={`${classes.paper} ${"modalBg"}`}>
            <img
              alt="CloseIcon"
              className="ClearModalImg"
              src={CloseIcon}
              onClick={(e) => {
                handleAlertCloseModal();
              }}
            />
            <div className="alert-icon">
              <img src={AlertIcon} alt="Alert icon" />
              <p>{alertMessage}</p>
              {alertMessage2 && (
                <>
                  {/* Condition for some confirmation conditions  */}
                  <p className="state_clear">{alertMessage2}</p>
                  <div className="modal_footer">
                    <button
                      className="btn btn-default senderBtn"
                      onClick={yesHandler}
                    >
                      {t("Yes")}
                    </button>
                    <button
                      className="btn btn-default cancel_btn"
                      onClick={handleAlertCloseModal}
                    >
                      {t("No")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </Fade>
      </Modal>
    </nav>
  );
};

export default withRouter(withTranslation()(AlertModal));
